// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__drFI-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1egdq","obliqueLine":"membershipbadge_obliqueLine__3SIVM"};